export const DATE_FORMAT = 'yyyy-MM-dd';

export const CALENDAR_TODAY_TYPE = {
  ECONOMIC: {
    INDEX: 'economic',
    TITLE: 'Economic',
    ROW_KEY: 'econcal_id',
  },
  DIVIDEND: {
    INDEX: 'dividend',
    TITLE: 'Dividend',
    ROW_KEY: 'dividend_id',
  },
  STOCKSPLIT: {
    INDEX: 'stocksplit',
    TITLE: 'Stock Split',
    ROW_KEY: 'stocksplit_id',
  },
  STOCK_REVERSE: {
    INDEX: 'stock_reverse',
    TITLE: 'Stock Reverse',
    ROW_KEY: 'stockreverse_id',
  },
  RIGHT_ISSUE: {
    INDEX: 'rightissue',
    TITLE: 'Right Issue',
    ROW_KEY: 'rightissue_id',
  },
  WARRANT: {
    INDEX: 'warrant',
    TITLE: 'Warrant',
    ROW_KEY: 'warrant_id',
  },
  BONUS: {
    INDEX: 'bonus',
    TITLE: 'Bonus',
    ROW_KEY: 'sahambonus_id',
  },
  TENDER_OFFER: {
    INDEX: 'tender',
    TITLE: 'Tender Offer',
    ROW_KEY: 'tender_id',
  },
  RUPS: {
    INDEX: 'rups',
    TITLE: 'RUPS',
    ROW_KEY: 'rups_id',
  },
  PUBEX: {
    INDEX: 'pubex',
    TITLE: 'PUBEX',
    ROW_KEY: 'puexp_id',
  },
  IPO: {
    INDEX: 'ipo',
    TITLE: 'IPO',
    ROW_KEY: 'ipo_id',
  },
};

export const CALENDAR_MENU_ITEMS = [
  'Today',
  'Economic',
  'Dividend',
  'Stock Split',
  'Reverse Split',
  'Right Issue',
  'Warrant',
  'Bonus',
  'Tender Offer',
  'RUPS',
  'Pubex',
  'IPO',
];
